<template>
  <section class="wrapper">
    <div class="logo"><img src="../../assets/img/wc-logo.png" alt=""></div>
    <div class="navbar">
      <a class="item first" :class="step===1?'active':''">1.填写个人信息</a>
      <a class="item second" :class="step===2?'active':''">2.填写公司信息</a>
      <a class="item">3.完成</a>
    </div>
    <one v-if="step===1" @save="save"></one>
    <two v-if="step===2" @save="save"></two>
    <div class="info">
      <van-checkbox v-model="checked" shape="square" icon-size="16px">我同意<span class="link">服务条款</span>
      </van-checkbox>
      <span @click="login" class="ml5 link">立即登录</span><i class="iconfont iconfont-right-copy"/>
    </div>
  </section>
</template>

<script>
  import one from '../register/one'
  import two from '../register/two'
  import {Register} from '@/api/register'

  export default {
    name: "register",
    components: {
      one,
      two
    },
    data() {
      return {
        step: 1,
        checked: true,
        registInfo: {}
      }
    },
    //已挂载，在模板渲染成html后调用，通常是初始化页面完成后，再对html的dom节点进行一些操作
    mounted() {
    },
    methods: {
      login() {
        this.$router.push("/login")
      },
      save(data) {
        this.registInfo = {
          ...this.registInfo,
          ...data
        };
        if (this.step === 1)
          this.step = 2;
        else if (this.step === 2) {
          this.submit();
        }
      },
      //提交注册
      async submit(){
        if(!this.checked){
          this.$toast.fail("请先同意服务条款");
        }
        else {
          let params = {
            LoginName: this.registInfo.registerName,
            NickName: this.registInfo.nickName,
            Language: this.registInfo.language,
            Password: this.registInfo.password,
            ConfirmPassword: this.registInfo.confirmPassword,
            OpenId: '',
            HeadImgUrl: '',
            CompanyID: this.registInfo.companyID,
            Name: this.registInfo.name,
            Country: this.registInfo.country,
            Province: this.registInfo.province,
            City: this.registInfo.city,
            District: this.registInfo.district,
            TaxType: this.registInfo.taxType,
            Taxpayer: this.registInfo.taxpayer,
            Currency: this.registInfo.currency,
            temp: this.registInfo.temp
          }
          let response = await Register(params);
          if (response.success) {
            if (response.code === '0000') {
              this.setCookie("UserInfo", {
                ...this.registInfo
              });
              this.$toast.success(response.msg)
              this.$router.push({path: '/company'})
            } else {
              this.$toast.fail(response.msg);
            }
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    background: white;
    .logo {
      padding: 1rem;

      img {
        width: 70%;
      }
    }

    .navbar {
      display: flex;
      padding: 1rem;

      .item {
        color: white;
        text-align: center;
        width: 37%;
        height: 3rem;
        line-height: 3rem;
        background: #e2e2e2;
        border-radius: 5rem;

        &:not(:first-child) {
          margin-left: -2rem;
        }

        &.first {
          z-index: 3;
        }

        &.second {
          z-index: 2;
          background: #d5d5d5;
        }

        &.active {
          background: #09a5bb
        }
      }
    }

    .info {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      font-size: 1.4rem;
      padding: 0 1rem;
      color: #ccc;
      height: 2rem;
      line-height: 2rem;

      .link {
        color: #00a1bb;
      }
    }
  }
</style>
